import React, { useEffect, useRef, useState } from "react";

export const VisualViewport = ({
  children,
  style,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  const ref = useRef<HTMLDivElement>(null)

  const [viewport, setViewport] = useState({
    height: "100vh",
    width: "100vw"
  })

  const updateViewport = () => {
    setViewport({
      height: window.visualViewport!.height + 'px',
      width: window.visualViewport!.width + 'px'
    })

    window.scrollTo(0, ref.current!.offsetTop);
  }

  useEffect(() => {
    if (window
      && window.visualViewport
    ) {
      updateViewport()

      window.visualViewport.addEventListener("resize", updateViewport)

      return () =>
        window.visualViewport!.removeEventListener("resize", updateViewport)
    }
  }, [])

  return (
    <div
      ref={ ref }
      style={ { ...style, ...viewport, display: 'flex', flexDirection: 'column' } }
      { ...props }
    >
      { children }
    </div>
  )
}